import './App.css';
import { Routes, Route, Navigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TwitterPostsSection from './components/TwitterPostsSection';
import AdminLayout from './components/admin/AdminLayout';
import AdminGuard from './components/admin/AdminGuard';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminHeroEdit from './components/admin/AdminHeroEdit';
import AdminMeetMeEdit from './components/admin/AdminMeetMeEdit';
import AdminSolutionsEdit from './components/admin/AdminSolutionsEdit';
import AdminQuoteEdit from './components/admin/AdminQuoteEdit';
import AdminGalleryEdit from './components/admin/AdminGalleryEdit';
import AdminServicesSectionEdit from './components/admin/AdminServicesSectionEdit';
import AdminCommunityEdit from './components/admin/AdminCommunityEdit';
import AdminProducts from './components/admin/AdminProducts';
import AdminAboutEdit from './components/admin/AdminAboutEdit';
import AdminBookings from './components/admin/AdminBookings';
import AdminAvailability from './components/admin/AdminAvailability';
import AdminServices from './components/admin/AdminServices';
import AdminTimeSlots from './components/admin/AdminTimeSlots';
import MeetMeSection from './components/MeetMeSection';
import SolutionsSection from './components/SolutionsSection';
import QuoteSection from './components/QuoteSection';
import GallerySection from './components/GallerySection';
import ServicesSection from './components/ServicesSection';
import CommunitySection from './components/CommunitySection';
import ProductsSection from './components/ProductsSection'; 
import Footer from './components/Footer';
import BookingSystem from './components/pages/BookingSystem';
import AboutPage from './components/pages/AboutPage';
import ServicesPage from './components/pages/ServicesPage';
import ProductsPage from './components/pages/ProductsPage';
import FAQPage from './components/pages/FAQPage';
import ContactPage from './components/pages/ContactPage';
import BlogsPage from './components/pages/BlogsPage';
import BlogPostPage from './components/pages/BlogPostPage';
import AdminBlogs from './components/admin/AdminBlogs';
import AdminBlogEdit from './components/admin/AdminBlogEdit';
import ReviewsPage from './components/pages/ReviewsPage';
import AdminReviews from './components/admin/AdminReviews';
import AdminReviewEdit from './components/admin/AdminReviewEdit';
import AdminFAQEdit from './components/admin/AdminFAQEdit';
import AdminContacts from './components/admin/AdminContacts';

function App() {
  


  return (
      <div className="App">
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={
              <>
              <Navbar />
              <Hero />
              <TwitterPostsSection />
              <MeetMeSection />
              <SolutionsSection />
              <QuoteSection />
              <GallerySection />
              <ServicesSection />
              <CommunitySection />
              <ProductsSection />
              <Footer />

              </>
            }
          />
          <Route
            path="/booking"
            element={
              <>
              <Navbar />
              <BookingSystem />
              <Footer />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
              <Navbar />
              <AboutPage />
              <Footer />
              </>
            }
          />
          <Route
            path="/services"
            element={
              <>
              <Navbar />
              <ServicesPage />
              <Footer />
              </>
            }
          />
          <Route
            path="/products"
            element={
              <>
              <Navbar />
              <ProductsPage />
              <Footer />
              </>
            }
          />
          <Route
            path="/faq"
            element={
              <>
              <Navbar />
              <FAQPage />
              <Footer />
              </>
            }
          />
          <Route
            path="/contact"
            element={
              <>
              <Navbar />
              <ContactPage />
              <Footer />
              </>
            }
          />
          <Route
            path="/blog"
            element={
              <>
              <Navbar />
              <BlogsPage />
              <Footer />
              </>
            }
          />
          <Route
            path="/blog/:slug"
            element={
              <>
              <Navbar />
              <BlogPostPage />
              <Footer />
              </>
            }
          />
          <Route
            path="/reviews"
            element={
              <>
              <Navbar />
              <ReviewsPage />
              <Footer />
              </>
            }
          />
          {/* Admin Panel */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminGuard />}>
            <Route element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="hero" element={<AdminHeroEdit />} />
              <Route path="meetme" element={<AdminMeetMeEdit />} />
              <Route path="solutions" element={<AdminSolutionsEdit />} />
              <Route path="quote" element={<AdminQuoteEdit />} />
              <Route path="gallery" element={<AdminGalleryEdit />} />
              <Route path="services-section" element={<AdminServicesSectionEdit />} />
              <Route path="community" element={<AdminCommunityEdit />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="about" element={<AdminAboutEdit />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="time-slots" element={<AdminTimeSlots />} />
              <Route path="availability" element={<AdminAvailability />} />
              <Route path="blog" element={<AdminBlogs />} />
              <Route path="blog/new" element={<AdminBlogEdit />} />
              <Route path="blog/:id" element={<AdminBlogEdit />} />
              <Route path="reviews" element={<AdminReviews />} />
              <Route path="reviews/new" element={<AdminReviewEdit />} />
              <Route path="reviews/:id" element={<AdminReviewEdit />} />
              <Route path="faq" element={<AdminFAQEdit />} />
              <Route path="contacts" element={<AdminContacts />} />
            </Route>
          </Route>
          <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
            </Routes>
      </div>
  );
}

export default App;
